<script>
import {mapActions, mapState} from "pinia";
import {authStore} from "@/store/authStore";
import Dialog from "primevue/dialog";
export default {
  name: "EmailExistModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(authStore, [
      'emailExistModalState'
    ]),
    modalState: {
      get() {
        return this.emailExistModalState;
      },
      set() {
        this.closeModal();
      },
    },
  },
  methods: {
    ...mapActions(authStore, [
      'toggleEmailExistModalState'
    ]),
    closeModal() {
      this.toggleEmailExistModalState();
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          class="reset-password-modal"
          modal
          :header="$t('validations.error')"
  >
    <div>
      {{$t('validations.userWithEmailExist')}}
    </div>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="closeModal()">
        {{$t('common.buttons.close')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">

</style>